import script from "./JsonRawViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./JsonRawViewer.vue?vue&type=script&setup=true&lang=js"

import "./JsonRawViewer.vue?vue&type=style&index=0&id=5fb36315&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fb36315"]])

export default __exports__